import { render, staticRenderFns } from "./educatorAndCars.vue?vue&type=template&id=18267445&scoped=true&"
import script from "./educatorAndCars.vue?vue&type=script&lang=js&"
export * from "./educatorAndCars.vue?vue&type=script&lang=js&"
import style0 from "./educatorAndCars.vue?vue&type=style&index=0&id=18267445&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18267445",
  null
  
)

export default component.exports